import { defineSlotRecipe } from "@pandacss/dev";

export const aromaSegmentedControl = defineSlotRecipe({
  className: "aroma-segmented-control",
  jsx: ["SegmentedControl"],
  slots: ["root", "item", "text", "indicator"],
  base: {
    root: {
      borderRadius: "l",
      gap: "gap.1",
      borderWidth: "m",
      borderColor: "border.neutral.bold",
      borderStyle: "solid",
      zIndex: "1",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      p: "padding.1",
      _vertical: {
        flexDirection: "column",
      },
      _horizontal: {
        height: "xl",
      },
    },
    indicator: {
      borderRadius: "s",
      bgColor: "background.neutral.base.subtle",
      width: "var(--width)",
      height: "var(--height)",
      top: "var(--top)",
      left: "var(--left)",
      transitionDuration: "0.2s!",
      zIndex: "-1",
    },
    item: {
      _vertical: {
        height: "m",
        width: "100%",
        justifyContent: "flex-start",
      },
      _horizontal: {
        height: "100%",
      },
      textStyle: "title.s",
      px: "padding.3",
      cursor: "pointer",
      display: "inline-flex",
      flexShrink: "0",
      whiteSpace: "nowrap",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "s",
      '& [data-part="item-text"]': {
        display: "inline-flex",
        gap: "gap.2",
        _aromaticonChildren: {
          fontSize: "{sizes.xs}",
        },
      },
      '&[data-icon="true"]': {
        p: "padding.1,5",
        _vertical: {
          justifyContent: "center",
        },
      },
      color: "content.neutral.base.subtle",
      _hover: {
        bgColor: "background.neutral.base.subtler-hover",
      },
      _focusVisible: {
        color: "content.neutral.base.bold",
        borderWidth: "l",
        borderColor: "border.brand",
        borderStyle: "solid",
      },
      _checked: {
        color: "content.neutral.base.bold",
        _hover: {
          bgColor: "transparent",
        },
      },
      _disabled: {
        color: "content.neutral.base.disable",
      },
    },
  },
  variants: {
    fullWidth: {
      true: {
        root: {
          display: "flex",
        },
        item: {
          display: "flex",
          _horizontal: {
            flex: "1",
          },
          _vertical: {
            height: "m",
          },
        },
      },
    },
  },
});
